<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
    @keydown.esc="close()"
  >
    <v-card>
      <v-card-title class="py-0"></v-card-title>
      <v-card-text class="py-0">
        <v-autocomplete
          :items="select"
          label="Cliente"
          item-text="ClRagSoc"
          item-value="ClRagSoc"
          v-model="cliente"
          return-object
          :loading="attesa"
          ref="inputSel"
          clearable
          no-data-text="Nessun dato disponibile"
        ></v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.native="close()">
          Annulla
        </v-btn>
        <v-btn
          color="primary"
          text
          @click.native="conferma()"
          :disabled="attesa"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get_listaClienti } from "@/api/api.admin.js";

export default {
  props: {
    dialog: { type: Boolean, default: false },
  },

  data: () => ({
    select: [],
    cliente: { ClCodCli: "", ClRagSoc: "" },
    attesa: false,
  }),

  methods: {
    caricaDati() {
      // Reset
      this.select = [];
      this.cliente = { ClCodCli: "", ClRagSoc: "" };

      // Controllo se ho salvato in precedenza la lista in vuex
      let clientiVuex = this.$store.getters["user/getClienti"];
      if (clientiVuex.length > 0) {
        this.select = clientiVuex;

        // Imposto quello attualmente selezionato
        this.impostaSelezionato();

        return;
      }
      // ----

      this.attesa = true;

      get_listaClienti()
        .then((res) => {
          this.select = res.data;

          // Inserisco "vuoto" (nella prima posizione)
          this.select.unshift({ ClCodCli: 0, ClRagSoc: "" });

          // Memorizzo in vuex i clienti
          this.$store.commit("user/SET_CLIENTI", this.select);

          // Imposto quello attualmente selezionato
          this.impostaSelezionato();

          this.attesa = false;
        })
        .catch((err) => {
          console.log("listaClienti.vue " + err);
          this.attesa = false;
        });
    },

    impostaSelezionato() {
      // Imposto quello attualmente selezionato
      this.cliente = {
        ClCodCli: this.$store.state.user.userSwitch.Codice,
        ClRagSoc: this.$store.state.user.userSwitch.Nome,
      };

      // Focus su combo
      this.$nextTick(() => this.$refs.inputSel.focus());
    },

    conferma() {
      let par = {};

      // Controllo vuoto
      if (this.cliente && this.cliente.ClCodCli) {
        par = {
          Codice: this.cliente.ClCodCli,
          Nome: this.cliente.ClRagSoc,
          Tipo: "Cliente",
        };
      }

      this.$store.commit("user/SET_USERSWITCH", par);

      this.close();
    },

    close() {
      this.$store.commit("app/SET_DIALOG", "");
    },
  },

  watch: {
    dialog(val) {
      if (!val) return;

      this.caricaDati();
    },
  },
};
</script>

